import request, { gql } from "graphql-request";

export const CREATECLIENT = gql`
  mutation CreateClient($input: CreateClientInput!) {
  createClient(input: $input) {
    client {
      id
      clientName
      mailAddress
      industry {
        id
      }
    }
    success
    error
    message
  }
}
`;

export const GETCLIENT = gql`
  query GetAllClients($search: String, $page: Int!, $pageSize: Int!) {
    getAllClients(search: $search, page: $page, pageSize: $pageSize) {
      success
      error
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      data {
        id
        clientName
        industry {
          id
          industryType
        }
        hiringType
        primaryContactPerson
        address
        mapLocation
        mailAddress
        countryCode
        contactNumber
        srDays
        createdAt
        createdBy
        lastUpdate
        updatedBy
      }
    }
  }
`;

export const GETClientBYID = gql`
  query GetClientById($id: Int!) {
  getClientById(id: $id) {
    success
    error
    message
    data {
      id
      clientName
      industry {
        id
        industryType
      }
      hiringType
      primaryContactPerson
      address
      mapLocation
      mailAddress
      countryCode
      contactNumber
      srDays
      createdAt
      createdBy
      lastUpdate
      updatedBy
    }
  }
}

`;

export const DELETECLIENT = gql`
 mutation DeleteClient($input: DeleteClientInput!) {
  deleteClient(input: $input) {
    client {
      id
      clientName
    }
    success
    error
    message
  }
}
`;

export const UPDATECREATECLIENT = gql`
 mutation UpdateClient($input: UpdateClientInput!) {
  updateClient(input: $input) {
    client {
      id
      clientName
      mailAddress
      industry {
        id
      }
    }
    success
    error
    message
  }
}
`;


export const EXPORTCLIENT = gql`
 mutation ExportClients($filters: ExportClientFilterInput!) {
  exportClients(filters: $filters) {
    success
    error
    message
    downloadUrl
  }
}
`;


export const GETINDUSTRYDROPDOWN = gql`
  query GetAllIndustries($search: String!, $page: Int!, $pageSize: Int!) {
    getAllIndustries(search: $search, page: $page, pageSize: $pageSize) {
      success
      error
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      data {
        id
        industryType
        hiringType
      }
    }
  }
`;

